import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class MachineRack extends DestroyableObstacle {
	static key = "MachineRack";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	static deserialize(data: any): MachineRack {
		const m = new MachineRack(deserializeXY(data.xy));
		m.restoreBaseFields(data);
		return m;
	}
}
